// A minute as football shows it (Ben, 2026-10-30: our "79'" was Google's "80'"). The data counts
// elapsed time from 0, so 86:30 is minute 86; a match clock shows the minute being played, 87'.
// Stoppage time reads as TV shows it: period 1's 46th minute is 45+2', not 47'.

/** Each period's last regular minute (first half, second half, the two extra-time halves). */
const PERIOD_END: Record<number, number> = { 1: 45, 2: 90, 3: 105, 4: 120 };

/** "87'", "45+2'", "90+3'". `minute` = elapsed minutes from the data (a fraction is fine);
 *  `period` (1–4), when known, turns minutes past its end into stoppage time. Pure. */
export function clockMinute(minute: number, period?: number | null): string {
  const elapsed = Math.floor(minute);
  const end = period ? PERIOD_END[period] : undefined;
  if (end !== undefined && elapsed >= end) return `${end}+${elapsed - end + 1}'`;
  return `${elapsed + 1}'`;
}
